import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Heart, Shield, Sparkles, Mail, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function About() {
  const { t } = useTranslation()
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
        <h1 className="font-display text-4xl font-bold mb-4">Nyxeverix {t('about.title')}</h1>
        <p className="text-lg text-muted-foreground">
          {t('about.intro')}
        </p>
      </motion.div>

      <div className="grid gap-8 mb-12">
        <div className="p-6 rounded-2xl bg-card border border-border">
          <Heart className="w-8 h-8 text-primary mb-4" />
          <h2 className="font-semibold text-xl mb-2">{t('about.mission')}</h2>
          <p className="text-muted-foreground">
            {t('about.description')}
          </p>
        </div>

        <div className="p-6 rounded-2xl bg-card border border-border">
          <Shield className="w-8 h-8 text-primary mb-4" />
          <h2 className="font-semibold text-xl mb-2">{t('about.valuesTitle')}</h2>
          <ul className="space-y-2 text-muted-foreground">
            <li>{t('about.values.empathy')}</li>
            <li>{t('about.values.privacy')}</li>
            <li>{t('about.values.positive')}</li>
            <li>{t('about.values.inclusivity')}</li>
          </ul>
        </div>

        <div className="p-6 rounded-2xl bg-card border border-border">
          <Sparkles className="w-8 h-8 text-primary mb-4" />
          <h2 className="font-semibold text-xl mb-2">{t('about.featuresTitle')}</h2>
          <ul className="space-y-2 text-muted-foreground">
            <li>{t('about.features.dailyLight')}</li>
            <li>{t('about.features.companion')}</li>
            <li>{t('about.features.moodMap')}</li>
            <li>{t('about.features.hopeChain')}</li>
          </ul>
        </div>
      </div>

      <div className="text-center p-8 rounded-2xl bg-primary/10 border border-primary/20">
        <Mail className="w-8 h-8 text-primary mx-auto mb-4" />
        <h2 className="font-semibold text-xl mb-2">{t('about.contactTitle')}</h2>
        <p className="text-muted-foreground mb-4">{t('about.contactEmail')}</p>
        <Link to="/support">
          <Button className="rounded-full">
            {t('about.supportButton')} <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
